<template>
  <eco-dialog
    :single="single"
    :data="data"
    :table-columns="tableColumns"
    :pagination="pagination"
    search-placeholder="名称"
    dialog-title="门户选择器"
    quick-search-props="name"
    :append-to-body="appendToBody"
    :destroy-on-close="destroyOnClose"
    @load="handleLoad"
    @onConfirm="onConfirm"
    ref="ecoDialog"
  />
</template>
<script>
import portal from "@/api/portal.js";

export default {
  name: "eip-portal-dialog",
  props: {
    value: Array,
    name: String,
    single: Boolean,
    appendToBody: {
      type: Boolean,
      default: false
    },
    destroyOnClose:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      data: [],
      tableColumns: [
        { prop: "name", label: "名称", width: "300" },
        { prop: "module", label: "别名" }
      ],
      pagination: {
        page: 1,
        pageSize: 50,
        total: 0,
        showTotal: true
      }
    };
  },
  methods: {
    showDialog() {
      this.$refs.ecoDialog.showDialog();
    },
    handleLoad(queryFilter, cb) {
        const data = {
            group: "advance",
            value: "index",
            relation: "AND",
            operation: "NOT_EQUAL",
            property: "MODULE",
        };
        queryFilter.querys.push(data);
        portal.getLayoutManagerPage(queryFilter)
            .then(response => {
                this.data = response.rows;
                this.pagination = {
                    page: response.page,
                    pageSize: response.pageSize,
                    total: response.total
                };
            })
            .finally(() => cb());
    },
    onConfirm(selection) {
      this.$emit("onConfirm", selection,this.name);
      this.$emit("input", selection);
    }
  }
};
</script>
